// Formats a number for offer sums and tables: always with a thousands separator and a fixed
// number of decimals, e.g. 12345.6 -> "12 345,60". The fixed decimals keep right-aligned
// columns lined up by the last digit.
const formatGroupedNumber = (
  value: number,
  decimals = 2,
  minimumDecimals = decimals
): string =>
  (Number.isFinite(value) ? value : 0).toLocaleString('fi', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: minimumDecimals,
    useGrouping: true,
  });

export default formatGroupedNumber;
